<template>
    <div class="indexContent column">
        <!-- 右侧悬浮 -->
        <div class="contactList">
            <div class="contactpos">
                <el-image :src="require('@/assets/icon/contact01.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">联系客服</div>
                <div class="contactContent contactShow">
                    <div class="contactHi">Hi,联系专属客服</div>
                    <div class="contactTitle">为您寻找最适合的产品解决方案</div>
                    <div class="contactBox column">
                        <!-- <el-image :src="indexData.kefu" class="contactImg"></el-image> -->
                        <div class="contactTips">扫码添加客服微信</div>
                    </div>
                </div>
            </div>
            <div class="contactpos" @click="goTop">
                <el-image :src="require('@/assets/icon/contact02.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">返回顶部</div>
            </div>
        </div>
        <!-- 搜索 -->
        <div class="searchFlex center">
             <div class="searchBox align">
                <el-input v-model="keyword" placeholder="请输入商品名称或商品ID" clearable class="searchIpt"></el-input>
                <div class="searchBtn" @click="hcSearchBtnTap()">搜索</div>
            </div>
        </div>
        <div class="goodsOneCatePosBox center" v-if="distanceFromTop < 0">
            <div class="goodsOneCatePos spb">
                <div class="cateSearchBox align">
                    <el-input v-model="keyword" placeholder="请输入商品名称或商品ID" clearable class="searchIpt"></el-input>
                    <div class="searchBtn" @click="hcSearchBtnTap()">搜索</div>
                </div>
                <div class="goodsOneCateList flex">
                    <div :class="['goodsOneCateBox column',oneActive == index ? 'goodsOneCateBoxOn' : '']" v-for="(item,index) in oneCate" :key="index"@click="oneCateTap(index)">
                        <div class="goodsOneCate">{{ item.name }}</div>
                        <div class="goodsOneIcon"></div>
                    </div>
                </div>
                <div class="batchBox align">
                    <div class="align" v-if="batchType">
                            <div class="batchExit" @click="batchType = false">{{ headTabId == '1' ? '退出批量选品' : '退出批量绑定' }}</div>
                            <div class="batchNum">已选{{ paramsNum }}<span style="color: #8C8C8C;">/100</span></div>
                            <div class="batchBtn" @click="batchTap">{{ headTabId == '1' ? '批量申请选品' : '批量申请绑定' }}</div>
                        </div>
                        <div class="batchExit" v-else @click="batchExitTap">{{ headTabId == '1' ? '批量选品' : '批量绑定' }}</div>
                </div>
            </div>
        </div>
        <div class="goodsContent">
            <div class="goodsCate" v-if="headTabId != '4' && headTabId != '5'">
                <div class="goodsOneCateContent spb">
                     <div class="goodsOneCateList flex">
                        <div :class="['goodsOneCateBox column',oneActive == index ? 'goodsOneCateBoxOn' : '']" v-for="(item,index) in oneCate" :key="index" @click="oneCateTap(index)">
                            <div class="goodsOneCate">{{ item.name }}</div>
                            <div class="goodsOneIcon"></div>
                        </div>
                    </div>
                    <div class="batchBox align">
                        <div class="align" v-if="batchType">
                            <div class="batchExit" @click="batchCancelTap">{{ headTabId == '1' ? '退出批量选品' : '退出批量绑定' }}</div>
                            <div class="batchNum">已选{{ paramsNum }}<span style="color: #8C8C8C;">/100</span></div>
                            <div class="batchBtn" @click="batchTap">{{ headTabId == '1' ? '批量申请选品' : '批量申请绑定' }}</div>
                        </div>
                        <div class="batchExit" v-else @click="batchExitTap">{{ headTabId == '1' ? '批量选品' : '批量绑定' }}</div>
                    </div>
                </div>
                <div class="goodsTwoCateList flex">
                    <div :class="['goodsTwoCateBox column',twoActive == index ? 'goodsTwoCateBoxOn' : '']" v-for="(item,index) in twoCate" :key="index" @click="twoCateTap(index)">{{ item.name }}</div>
                </div>
            </div>
            <div class="goodsCate" v-else>
                <div class="goodsOneCateContent spb">
                    <div class="goodsTwoCateList flex">
                        <div :class="['goodsTwoCateBox align',item.active ? 'goodsTwoCateBoxOn' : '']" v-for="(item,index) in oneCate" :key="index" @click="item.active = !item.active">
                            <el-image :src="require(item.active ? '@/assets/icon/cateActiveOn.png' : '@/assets/icon/cateActive.png')" fit="cover" class="twoCateIcon"></el-image>
                            <div class="twoCateName">{{ item.name }}</div>
                        </div>
                        <div class="cateAll" @click="cateAllTap">全选</div>
                    </div>
                    <div class="batchBox align">
                        <div class="align">
                            <!-- <div class="batchNum">已选{{ cateNum }}<span style="color: #8C8C8C;">/100</span></div> -->
                            <div class="batchBtn" @click="synCateTap">批量申请选品</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="goodsList" ref="targetElement">
                <!-- 选品库商品 -->
                <div class="flex" v-if="headTabId == '1'">
                    <div :class="['xpkGoodsBox',batchType ? '' : 'xpkGoodsBoxHover']" v-for="(item,index) in goodsData" :key="index" @click="xpkGoodsTap(index,item.product_id)">
                        <div class="xpkGoodsImgBox">
                            <!-- <el-image :src="require('@/assets/icon/collection.png')" fit="cover" class="collection" @click.stop="collectionTap(index,item.product_id)"></el-image> -->
                            <el-image :src="item.head_imgs" fit="cover" class="xpkGoodsImg"></el-image>
                            <div class="addBox">
                                <div class="center">
                                     <el-image :src="require('@/assets/icon/add.png')" fit="cover" class="addIcon"></el-image>
                                    <div class="add">选品</div>
                                </div>
                            </div>
                            <el-image :src="require(item.active ? '@/assets/icon/activeOn.png' : '@/assets/icon/active.png')" fit="cover" class="xpkActive" v-if="batchType"></el-image>
                            <div class="xpkShopBox align">
                                <el-image :src="item.shopicon" fit="cover" class="xpkShopIcon"></el-image>
                                <div class="xpkShopName">{{ item.shopname }}</div>
                            </div>
                        </div>
                        <div class="xpkBottom">
                            <div class="xpkTitle twoRow">{{ item.title }}</div>
                            <div class="align" style="margin-top: 6px;">
                                <div class="xpkPrice"><span class="xpkPriceIcon">￥</span>{{ item.sale_price }}</div>
                                <div class="couponBox align" v-if="item.coupon != ''">
                                    <el-image :src="require('@/assets/icon/coupon.png')" fit="cover" class="couponIcon"></el-image>
                                    <div class="couponNum">￥{{ item.coupon }}</div>
                                </div>
                            </div>
                            <div class="xpkComList spb">
                                <div class="xpkComBox column">
                                    <div class="comTitle">定向高佣</div>
                                    <div class="comNum xpkColor align">{{ item.service_ratio }}<span class="comNumIcon">%</span><span class="comNumIcon" style="padding-left: 4px;">赚¥{{ item.yongjin }}</span></div>
                                </div>
                                <div class="xpkComBox column">
                                    <div class="comTitle">公开佣金</div>
                                    <div class="comNum">{{ item.putong }}<span class="comNumIcon">%</span></div>
                                </div>
                            </div>
                            <div class="sales">热销<span class="xpkColor">{{ item.sales }}</span></div>
                        </div>
                    </div>
                </div>
                <!-- 直播间商品 -->
                 <div class="flex" v-if="headTabId == '2'">
                    <div class="zbjGoodsBox between" v-for="(item,index) in goodsData" :key="index" @click="zbjGoodsTap(index,item.id,item.type)">
                        <el-image :src="require(item.active ? '@/assets/icon/activeOn.png' : '@/assets/icon/active.png')" fit="cover" class="zbjActive" v-if="batchType"></el-image>
                        <el-image :src="item.head_imgs" fit="cover" class="zbjGoodsImg"></el-image>
                        <div class="zbjR">
                            <div class="zbjTitleBox align">
                                <div class="zbjTitle">{{ item.title }}</div>
                                <div class="zbjType align">
                                    <el-image :src="require(item.type == '0' ? '@/assets/icon/zbj02.png' : '@/assets/icon/zbj01.png')" fit="cover" class="zbjTypeIcon"></el-image>
                                    <div :class="['zbjTypeName',item.type == '0' ? 'zbjTypeNameDa' : '']">{{ item.type == '0' ? '达播' : item.type == '1' ? '店播' : '' }}</div>
                                </div>
                            </div>
                           <div class="zbjText oneRow">{{ item.description }}</div>
                           <div class="zbjComBox between">
                                <div class="zbjCom">佣金<span class="zbjComNum">{{ item.service_ratio }}</span></div>
                                <div class="zbjBtn">申请绑定</div>
                           </div>
                        </div>
                    </div>
                 </div>
            </div>
            <!-- loading -->
            <div class="webLoading" v-if="headTabId == '1'">{{ more == 'loading' ? '加载中...' : more == 'more' ? '下拉加载更多' : more == 'noMore' ? '到底啦~看看其他精选内容 ' : '' }}</div>
        </div>
        <!-- 绑定直播间弹窗 -->
        <el-dialog title="批量绑定直播间" width="730px" :visible.sync="dialogZbj" @close="dialogZbjClose()">
            <div class="bindZbjBox">
                <div class="bindTitle">机构名称</div>
                <el-input v-model="bindName" placeholder="请输入机构名称" clearable class="bindIpt"></el-input>
                <div class="bindTitle" v-if="bindType == '1' || bindType == '2'">机构链接</div>
                <el-input type="textarea" :rows="5" resize="none" placeholder="请输入机构链接" v-model="bindLink" class="bindArea" v-if="bindType == '1' || bindType == '2'"></el-input>
                <div class="bindTitle" v-if="bindType == '0' || bindType == '2'">机构码</div>
                <div class="bindImgBox" v-if="bindType == '0' || bindType == '2'">
                    <el-image :src="require('@/assets/icon/close.png')" fit="cover" class="bindImgDel" v-if="bindImg != ''" @click.stop="bindImg = ''"></el-image>
                    <el-upload class="avatar-uploader" action="https://www.xiaodiantuike.com/api/common/upload" :show-file-list="false" :on-success="handleAvatarSuccess">
                        <img v-if="bindImg" :src="bindImg" class="bindImg">
                        <div v-else class="bindUpBox">
                            <el-image :src="require('@/assets/icon/upload.png')" fit="cover" class="bindUpIcon"></el-image>
                            <div class="bindUpTips">上传机构码</div>
                        </div>
                    </el-upload>
                </div>
                <div class="bindBtn" @click="bindTap">提 交</div>
            </div>
        </el-dialog>
        <!-- 选品库弹窗 -->
        <div class="xpMask center" v-if="xpShow">
            <div class="xpPopup column">
                <el-image :src="require('@/assets/icon/close02.png')" fit="cover" class="xpClose" @click="xpCloseTap"></el-image>
                <div class="xpTop center">
                    <el-image :src="require('@/assets/icon/tips01.png')" fit="cover" class="xpTopIcon"></el-image>
                    <div class="xpTopText">您的机构暂未与平台建立合作。请根据下方指引进行邀约合作</div>
                </div>
                <el-image :src="xpTips[xpTipsActive].img" :preview-src-list="xpTipsBig" fit="cover" class="xpImg"></el-image>
                <div class="xpTipsBox center">
                    <div class="xpTipsText">{{ xpTips[xpTipsActive].text }}</div>
                    <div class="xpTipsNum">({{ xpTipsActive + 1 }}/{{ xpTips.length }})</div>
                </div>
                <div class="xpBtnBox center">
                    <div class="xpBtnPrve" v-if="xpTipsActive != '0'" @click="xpBtnPrveTap">上一步</div>
                    <div class="xpBtnNext" v-if="(xpTipsActive + 1) != xpTips.length" @click="xpBtnNextTap">下一步</div>
                    <div class="xpBtnNext" v-else @click="xpCloseTap">关闭</div>
                </div>
            </div>
        </div>
        <!-- 同步弹窗 -->
         <el-dialog title="同步品牌分类" width="500px" :visible.sync="dialogSyn" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div class="synBox" v-if="cateList.length > 0">
                <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage" text-color="#fff"></el-progress>
                <div class="column">
                    <div class="synTitle">正在同步...</div>
                    <div class="synTips">正在同步 ⌈{{cateList[cateIndex].name}}⌋ 品牌的选品。</div>
                    <div class="synBtn align">
                        <div class="synRetry" v-if="!failure" @click="cancelTap">取消同步</div>
                        <div class="synRetry" v-if="failure">重试</div>
                        <div class="synNext" v-if="failure">同步下一个</div>
                    </div>
                </div>
            </div>
         </el-dialog>
    </div>
</template>

<script>
    import { EventBus } from '@/common/js/eventBus.js';
    export default {
        data(){
            return {
                userId: 0,
                keyword: '',
                headTabActive: 0,
                headTabId: '',
                oneCate: [],
                oneActive: 0,
                twoCate: [],
                twoActive: 0,
                distanceFromTop: 0,
                goodsData: [],
                page: 1,
                more: 'loading',
                batchType: false,
                paramsNum: 0,
                params: [],
                cateNum: 0,
                cateList: [],
                cateIndex: 0,
                dialogZbj: false,
                bindType: '',
                bindName: '',
                bindLink: '',
                bindImg: '',
                xpShow: false,
                xpTips: [],
                xpTipsBig: [],
                xpTipsActive: 0,
                dialogSyn: false,
                failure: false,
                cateGoodsNum: 0,
                percentage: 0,
            }
        },
        mounted(){
            EventBus.$on('headTabTap', this.headTabClick);
            this.userId = localStorage.getItem("userId")
            document.title = '小店客'
            // this.updateDistance();
            // 监听滚动和窗口大小变化
            window.addEventListener('scroll', this.updateDistance);
            window.addEventListener('resize', this.updateDistance);
            this.getBindData()
        },
        beforeDestroy() {
            // 移除事件监听
            EventBus.$off('headTabTap', this.headTabClick);
            window.removeEventListener('scroll', this.updateDistance);
            window.removeEventListener('resize', this.updateDistance);
        },
        methods: {
            // 列表重置封装
            getReset(){
                this.page = 1
                this.batchType = false
            },
            // 网站头tab切换
            headTabClick(e,i) {
                console.log('Header 被点击了！',e,i);
                this.headTabActive = e
                this.headTabId = i
                this.oneActive = 0
                this.twoActive = 0
                this.page = 1
                this.goodsData = []
                this.getReset()
                this.getResetBind()
                this.getOneCate(i)
            },
            // 监听窗口滚动
            updateDistance() {
                if(this.headTabId == '1'){
                    if (this.$refs.targetElement) {
                        this.distanceFromTop = this.$refs.targetElement.getBoundingClientRect().top;
                    }
                    const bottomOfWindow = document.documentElement.clientHeight + window.scrollY >= document.body.scrollHeight;
                    if (bottomOfWindow) {
                        console.log('已滚动到页面底部');
                        this.page++
                        this.getGoodsData()
                        // 执行你的逻辑，例如加载更多数据
                    }
                }
            },
            // 获取填写历史
            getBindData(e){
                this.request.get("index/index/getjigouname",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    let obj = res.data
                    this.bindName = obj.jigouname
                    this.bindLink = obj.link
                    this.bindImg = obj.img
                })
            },
            // 一级分类
            getOneCate(e){
                let url = this.headTabId == '5' ? 'index/baipai/cate2' : 'index/index/cate2'
                this.request.get(url,{
                    params:{
                       id: e
                    }
                })
                .then(res=>{
                    this.oneCate = res.data
                    if(this.headTabId != '4' && this.headTabId != '5'){
                        this.getTwoCate()
                    }
                })
            },
            // 二级分类
            getTwoCate(){
                this.request.get("index/index/cate3",{
                    params:{
                       id: this.oneCate[this.oneActive].id
                    }
                })
                .then(res=>{
                    this.twoCate = res.data
                    this.getGoodsData()
                })
            },
            // 一级分类点击
            oneCateTap(e){
                this.goTop()
                this.getResetBind()
                this.oneActive = e
                this.twoActive = 0
                this.page = 1
                this.getTwoCate()
            },
            // 二级分类点击
            twoCateTap(e){
                this.goTop()
                this.getResetBind()
                this.twoActive = e
                this.page = 1
                this.getGoodsData()
            },
            // 获取列表数据
            getGoodsData(){
                this.more = 'loading'
                this.request.get("index/index/goods",{
                    params:{
                       page: this.page,
                       pagesize: '20',
                       cate1: this.headTabId,
                       cate2: this.oneCate[this.oneActive].id,
                       cate3: this.twoCate[this.twoActive].id
                    }
                })
                .then(res=>{
                    if(this.page == '1'){
                        this.goodsData = res.data
                    }else{
                        this.goodsData.push(...res.data)
                    }
                    this.more = res.data.length == 20 ? 'more' : 'no-more'
                })
            },
            // 收藏
            collectionTap(i,e){
                console.log(i,e)
            },
            // 选品库商品点击
            xpkGoodsTap(i,e){
                console.log('选品库商品点击')
                if(this.batchType){
                    if(this.paramsNum > 99){
                        this.$message({
                            message: '一次最多选择100条',
                            type: 'warning'
                        });
                        return
                    }
                    if(this.goodsData[i].active){
                        this.paramsNum--
                    }else{
                        this.paramsNum++
                    }
                    this.goodsData[i].active = !this.goodsData[i].active
                }else{
                    this.params = []
                    let obj = {}
                    obj.product_id = e
                    this.params.push(obj)
                    this.bindTap()
                }
            },
            // 直播间商品点击
            zbjGoodsTap(i,e,t){
                if(this.batchType){
                    if(this.paramsNum > 99){
                        this.$message({
                            message: '一次最多选择100条',
                            type: 'warning'
                        });
                        return
                    }
                    if(this.goodsData[i].active){
                        this.paramsNum--
                    }else{
                        this.paramsNum++
                    }
                    this.goodsData[i].active = !this.goodsData[i].active
                }else{
                    this.bindType = t
                    this.params = []
                    let obj = {}
                    obj.id = e
                    this.params.push(obj)
                    console.log(this.params)
                    this.dialogZbj = true
                }
            },
            // 批量
            batchTap(){
                if(this.paramsNum == '0'){
                    this.$message({
                        message: '至少选择一条数据',
                        type: 'warning'
                    });
                    return
                }
                let mapNum = 0
                
                if(this.headTabId == '1'){
                    this.goodsData.map((el,index) =>{
                        let obj = {}
                        if(el.active){
                            obj.product_id = el.product_id
                            this.params.push(obj)
                        }
                        mapNum++
                        if(mapNum == this.goodsData.length){
                            console.log(this.params)
                            this.bindTap()
                        }
                    })
                }
                if(this.headTabId == '2'){
                    let linkType = 0
                    let codeType = 0
                    this.goodsData.map((el,index) =>{
                        let obj = {}
                        if(el.active){
                            obj.id = el.id
                            this.params.push(obj)
                            if(el.type == 0){
                                codeType++
                            }
                            if(el.type == 1){
                                linkType++
                            }
                        }
                        mapNum++
                        if(mapNum == this.goodsData.length){
                            if(linkType > 0 && codeType == 0){
                                this.bindType = '1'
                            }
                            if(linkType == 0 && codeType > 0){
                                this.bindType = '0'
                            }
                            if(linkType > 0 && codeType > 0){
                                this.bindType = '2'
                            }
                            console.log(this.params)
                            this.dialogZbj = true
                        }
                    })
                }
            },
            // 上传图片
            handleAvatarSuccess(res) {
                this.bindImg = res.data.fullurl
            },
            // 直播间申请绑定封装
            bindTap(){
                if(this.headTabId == '1'){
                    const loading = this.$loading({
                        lock: true,
                        text: '请稍候...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.request.post("index/index/xuanpin",{
                        params:{
                            params: this.params
                        }
                    })
                    .then(res=>{
                        loading.close();
                        if(res.code != '2'){
                            this.$message({
                                message: res.msg,
                                type: res.code == '0' ? 'warning' : 'success'
                            });
                        }
                        if(res.code == '1'){
                            this.goodsData.map((el) => {
                                el.active = false
                            })
                            this.getResetBind()
                        }
                        if(res.code == '2'){
                            this.xpTipsBig = []
                            res.data.map((el) => {
                                this.xpTipsBig.push(el.img)
                            })
                            this.xpTips = res.data
                            this.xpShow = true
                        }
                    })
                }
                if(this.headTabId == '2'){
                     if(this.bindName == '' || (this.bindType == '0' && this.bindImg == '') || (this.bindType == '1' && this.bindLink == '') || (this.bindType == '2' && (this.bindImg == '' || this.bindLink == ''))){
                        this.$message({
                            message: '请填写完整信息',
                            type: 'warning'
                        });
                        return
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: '请稍候...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.request.post("index/index/bangding",{
                        params:{
                        jigouname: this.bindName,
                        link: this.bindLink,
                        img: this.bindImg,
                        params: this.params
                        }
                    })
                    .then(res=>{
                        loading.close();
                        this.$message({
                            message: res.msg,
                            type: res.code == '0' ? 'warning' : 'success'
                        });
                        if(res.code == '1'){
                            this.goodsData.map((el) => {
                                el.active = false
                            })
                            this.dialogZbj = false
                            this.getResetBind()
                        }
                    })
                }
            },
            // 重置绑定数据封装
            getResetBind(){
                this.batchType = false
                this.paramsNum = 0
                this.params = []
            },
            // 关闭直播间申请绑定弹窗
            dialogZbjClose(){
                this.params = []
            },
            // 批量
            batchExitTap(){
                this.batchType = true
                this.params = []
            },
            // 退出批量
            batchCancelTap(){
                this.batchType = false
                this.params = []
            },
            // 上一步
            xpBtnPrveTap(){
                if(this.xpTipsActive != '0'){
                    this.xpTipsActive--
                }
            },
            // 下一步
            xpBtnNextTap(){
                if(this.xpTipsActive != this.xpTips.length){
                    this.xpTipsActive++
                }
            },
            // 关闭选品库弹窗
            xpCloseTap(){
                this.xpTipsActive = 0
                this.xpShow = false
            },
            // 品牌分类选择分类
            pinpaiTap(i){
                // this.cateNum = this.oneCate[i].active ? this.cateNum-1 : this.cateNum+1
                this.oneCate[i].active = !this.oneCate[i].active
            },
            // 全选
            cateAllTap(){
                let allNum = 0
                this.oneCate.map((el,index) => {
                    if(el.active){
                        allNum++
                    }
                    if(index == this.oneCate.length-1){
                        this.oneCate.map((ele,ii) => {
                            ele.active = allNum == this.oneCate.length ? false : true
                        })
                    }
                })
            },
            // 批量分类同步
            synCateTap(){
                this.cateList = []
                this.oneCate.map((el,index) => {
                    if(el.active){
                        this.cateList.push(el)
                    }
                    if(index == this.oneCate.length-1){
                        console.log(this.cateList)
                        // for(var i = 0;i < this.cateList.length-1;i++){
                        //     this.request.get("index/index/catexuanpin",{
                        //         params:{
                        //             cateid: this.cateList[i].id,
                        //             product_id: e || 0
                        //         }
                        //     })
                        //     .then(res=>{
                                
                        //     })
                        // }
                        if(this.cateList.length == '0'){
                            this.$message({
                                message: '至少选择一个分类',
                                type: 'warning'
                            });
                        }else{
                            console.log('同步')
                            this.dialogSyn = true
                            this.getSynCate(0)
                        }
                    }
                })
            },
            // 批量分类同步接口封装
            getSynCate(e){
                if(this.dialogSyn){
                    let url = this.headTabId == '4' ? 'index/index/catexuanpin' : this.headTabId == '5' ? 'index/baipai/catexuanpin' : ''
                    this.request.get(url,{
                        params:{
                            cateid: this.cateList[this.cateIndex].id,
                            product_id: e
                        }
                    })
                    .then(res=>{
                        if(res.code == '0'){
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                            this.dialogSyn = false
                            this.cateIndex = 0
                            this.cateGoodsNum = 0
                            this.percentage = 0
                        }
                        if(res.code == '1'){
                            this.getSynCate(res.data.product_id)
                            this.cateGoodsNum = this.cateGoodsNum + res.data.num
                            this.percentage = Math.floor((this.cateGoodsNum/res.data.total)*100) > 100 ? 100 : Math.floor((this.cateGoodsNum/res.data.total)*100)
                        }
                        if(res.code == '2'){
                            this.dialogSyn = false
                            this.xpTipsBig = []
                            res.data.map((el) => {
                                this.xpTipsBig.push(el.img)
                            })
                            this.xpTips = res.data
                            this.xpShow = true
                        }
                        if(res.code == '5'){
                            if(this.cateIndex == this.cateList.length - 1){
                                this.dialogSyn = false
                                this.cateIndex = 0
                                this.cateGoodsNum = 0
                                this.percentage = 0
                                this.$message({
                                    message: '同步完成',
                                    type: 'success'
                                });
                            }else{
                                this.cateIndex++
                                this.cateGoodsNum = 0
                                this.getSynCate(0)
                            }
                        }
                    })
                }
            },
            // 取消同步
            cancelTap(){
                this.$confirm('此操作将取消所有未同步完成品牌的同步, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.dialogSyn = false
                    this.cateIndex = 0
                    this.cateGoodsNum = 0
                    this.percentage = 0
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                }).catch(() => {
                             
                });
            },
            // 回到顶部
            goTop(){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // 使滚动平滑
                });
            },
            
        }
    }
</script>
<style lang="less" scoped>
    .indexContent{
        .typewriterBox{
            width: 100%;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
            animation: fadeInUp 0.5s ease-out;
            .typewriterText{
                font: bold 24px/30px "MicrosoftYaHei";
                position: relative;
                display: inline-block;
                
                /deep/ .gradient-text {
                    background: linear-gradient( to right, #FF6146 0%, #FF8B78 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                
                /deep/ .highlight-text {
                    background: linear-gradient( to right, #FF2020 0%, #FF6C36 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    font-weight: bold;
                }
                
                /deep/ .normal-text {
                    color: #333;
                    -webkit-text-fill-color: initial;
                }
                
                /deep/ .desc-text {
                    color: #666;
                    font-size: 20px;
                    -webkit-text-fill-color: initial;
                }
                
                /deep/ .emphasis-text {
                    background: linear-gradient( to right, #FF6A00 0%, #FF8B78 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    font-weight: bold;
                }
                
                &::after{
                    content: '|';
                    position: absolute;
                    right: -10px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #FF6146;
                    animation: blink 0.8s infinite;
                }
            }
        }
        
        @keyframes fadeInUp{
            from{
                opacity: 0;
                transform: translateY(20px);
            }
            to{
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        @keyframes blink{
            0%, 100%{
                opacity: 1;
            }
            50%{
                opacity: 0;
            }
        }
       .contactList{
            width: 72px;
            position: fixed;
            right: 20px;
            bottom: 10vh;
            z-index: 999;
            .contactpos{
                width: 72px;
                height: 72px;
                border-radius: 8px;
                background: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 8px;
                cursor: pointer;
                position: relative;
                &:hover{
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    .contactShow{
                        display: block;
                    }
                }
                .contactIcon{
                    width: 24px;
                    height: 24px;
                }
                .contactName{
                    font: 12px/16px "MicrosoftYaHei";
                    color: #73727A;
                    margin-top: 6px;
                }
                .contactContent{
                    width: 230px;
                    border-radius: 8px;
                    background: #FF6A00;
                    position: absolute;
                    left: -236px;
                    bottom: 0;
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    display: none;
                    .contactHi{
                        padding: 18px 0 0 18px;
                        font: bold 14px/18px "MicrosoftYaHei";
                        color: #fff;
                    }
                    .contactTitle{
                        padding: 6px 0 0 18px;
                        font: 12px/14px "MicrosoftYaHei";
                        color: #fff;
                    }
                    .contactBox{
                        width: 230px;
                        height: 202px;
                        // border-radius: 8px 8px 0 0;
                        background: #fff;
                        margin-top: 12px;
                        .contactImg{
                            width: 138px;
                            height: 138px;
                            border-radius: 12px;
                            margin-top: 21px;
                        }
                        .contactTips{
                            font: 12px/14px "MicrosoftYaHei";
                            color: #73727A;
                            margin-top: 6px;
                        }
                    }
                }
            }
       }
       .searchFlex{
            width: 1232px;
            padding: 32px 0 24px 0;
            .searchBox{
                width: 500px;
                height: 36px;
                padding: 2px;
                display: flex;
                align-items: center;
                border: 2px solid #FF6A00;
                border-radius: 22px;
                overflow: hidden;
                .searchIpt{
                    flex: 1;
                    padding: 0 14px;
                    font: 14px/36px "MicrosoftYaHei";
                    :deep(.el-input__wrapper) {
                        box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
                        cursor: default;
                        .el-input__inner {
                            cursor: default !important;
                        }
                    }
                }
                .searchBtn{
                    width: 80px;
                    height: 36px;
                    border-radius: 18px;
                    background: #FF6146;
                    font: 16px/36px "MicrosoftYaHei";
                    color: #fff;
                    text-align: center;
                    cursor: pointer;
                }
            }
       }
       .goodsOneCatePosBox{
            width: 100vw;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 9;
            .goodsOneCatePos{
                width: 1200px;
                padding: 0 16px;
                background: #fff;
                border-radius: 0 0 24px 24px;
                .cateSearchBox{
                    width: 246px;
                    height: 28px;
                    padding: 2px;
                    display: flex;
                    align-items: center;
                    border: 1px solid #FF6A00;
                    border-radius: 22px;
                    overflow: hidden;
                    margin-top: 10px;
                    .searchIpt{
                        flex: 1;
                        padding: 0 14px;
                        font: 14px/28px "MicrosoftYaHei";
                        :deep(.el-input__wrapper) {
                            box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
                            cursor: default;
                            .el-input__inner {
                                cursor: default !important;
                            }
                        }
                    }
                    .searchBtn{
                        width: 64px;
                        height: 28px;
                        border-radius: 18px;
                        background: #FF6146;
                        font: 14px/28px "MicrosoftYaHei";
                        color: #fff;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
       }
       .goodsOneCateList{
            flex: 1;
            .goodsOneCateBox{
                height: 52px;
                padding: 0 20px;
                overflow: hidden;
                margin-right: 8px;
                cursor: pointer;
                .goodsOneCate{
                    font: 16px/22px "MicrosoftYaHei";
                    color: #333;
                    margin-top: 15px;
                }
                .goodsOneIcon{
                    width: 40px;
                    height: 12px;
                    border-radius: 6px;
                    filter: blur(10px);
                    margin-top: 8px;
                }
            }
            .goodsOneCateBoxOn{
                .goodsOneCate{
                    color: #FF6146 !important;
                }
                .goodsOneIcon{
                    background: #FFCFC7;
                }
            }
        }
        .batchBox{
            padding-left: 16px;
            height: 52px;
            .batchExit{
                padding: 0 16px;
                height: 30px;
                border-radius: 16px;
                border: 1px solid #F0F0F0;
                font: 14px/30px "MicrosoftYaHei";
                cursor: pointer;
            }
            .batchNum{
                padding-left: 32px;
                font: 14px/52px "MicrosoftYaHei";
            }
            .batchCollection{
                padding: 0 16px;
                height: 30px;
                border-radius: 16px;
                border: 1px solid #FAE9E6;
                font: 14px/30px "MicrosoftYaHei";
                color: #FF6146;
                cursor: pointer;
                margin-left: 10px;
            }
            .batchBtn{
                padding: 0 16px;
                height: 32px;
                background: #FF6146;
                border-radius: 16px;
                font: 14px/32px "MicrosoftYaHei";
                color: #fff;
                cursor: pointer;
                margin-left: 10px;
            }
        }
       .goodsContent{
            width: 1232px;
            background: rgba(0,0,0,0.02);
            border-radius: 24px;
            .goodsCate{
                width: 1200px;
                padding: 0 16px;
                background: #fff;
                border-radius: 24px;
                .goodsOneCateContent{
                    border-bottom: 1px solid #F5F5F5;
                }
                .goodsTwoCateList{
                    flex: 1;
                    padding-bottom: 16px;
                    .goodsTwoCateBox{
                        padding: 0 10px;
                        height: 32px;
                        background: #F6F6F6;
                        border-radius: 8px;
                        font: 12px/32px "MicrosoftYaHei";
                        color: #595959;
                        margin: 8px 8px 0 0;
                        cursor: pointer;
                        .twoCateIcon{
                            width: 16px;
                            height: 16px;
                        }
                        .twoCateName{
                            padding-left: 4px;
                        }
                    }
                    .goodsTwoCateBoxOn{
                        background: #FFF5F3 !important;
                        color: #FF6146 !important;
                    }
                    .cateAll{
                        padding: 0 10px;
                        height: 32px;
                        font: 12px/32px "MicrosoftYaHei";
                        color: #FF6146;
                        margin: 8px 8px 0 0;
                        cursor: pointer;
                    }
                }
            }
            .goodsList{
                width: 1216px;
                padding: 0 8px;
                .xpkGoodsBox{
                    width: 225px;
                    height: 388px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid rgba(0,0,0,0.02);
                    margin: 8px;
                    cursor: pointer;
                    &:hover{
                        border: 1px solid #FF6146;
                    }
                    .xpkGoodsImgBox{
                        width: 225px;
                        height: 225px;
                        overflow: hidden;
                        position: relative;
                        .collection{
                            width: 24px;
                            height: 24px;
                            padding: 10px;
                            position: absolute;
                            right: 0;
                            top: 0;
                            z-index: 3;
                        }
                        .xpkGoodsImg{
                            width: 225px;
                            height: 225px;
                            border-radius: 8px;
                        }
                        .addBox{
                            width: 225px;
                            height: 30px;
                            background: rgba(255,97,70,0.85);
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            z-index: 3;
                            cursor: pointer;
                            display: none;
                            .addIcon{
                                width: 16px;
                                height: 16px;
                            }
                            .add{
                                font: 12px/30px "MicrosoftYaHei";
                                color: #fff;
                                padding-left: 4px;
                            }
                        }
                        .xpkActive{
                            width: 22px;
                            height: 22px;
                            position: absolute;
                            right: 10px;
                            top: 10px;
                        }
                        .xpkShopBox{
                            padding: 0 4px;
                            height: 20px;
                            background: linear-gradient( to right, #FF2020 0%, #FF6C36 100%);
                            border-radius: 8px 8px 8px 0;
                            position: absolute;
                            left: 0;
                            top: 0;
                            .xpkShopIcon{
                                width: 16px;
                                height: 16px;
                                border-radius: 50%;
                            }
                            .xpkShopName{
                                font: 12px/20px "MicrosoftYaHei";
                                color: #fff;
                            }
                        }
                    }
                    .xpkBottom{
                        width: 201px;
                        padding: 0 12px;
                        .xpkTitle{
                            height: 32px;
                            font: 12px/16px "MicrosoftYaHei";
                            color: #595959;
                            margin-top: 8px;
                        }
                        .xpkPrice{
                            font: 18px/22px "MicrosoftYaHei";
                            .xpkPriceIcon{
                                font: 14px/22px "MicrosoftYaHei";
                            }
                        }
                        .couponBox{
                            height: 18px;
                            background: #FFF5F5;
                            border-radius: 4px;
                            border: 1px solid #FFD2D2;
                            margin-left: 4px;
                            .couponIcon{
                                width: 18px;
                                height: 18px;
                            }
                            .couponNum{
                                padding: 0 2px;
                                font: 12px/18px "MicrosoftYaHei";
                                color: #ED116D;
                            }
                        }
                        .xpkComList{
                            width: 201px;
                            height: 44px;
                            padding: 4px 0;
                            background: #FAFAFA;
                            border-radius: 8px;
                            margin-top: 8px;
                            .xpkComBox{
                                width: 100px;
                                .comTitle{
                                    font: 12px/16px "MicrosoftYaHei";
                                    color: #8C8C8C;
                                }
                                .comNum{
                                    font: 18px/24px "MicrosoftYaHei";
                                    color: #333;
                                    margin-top: 4px;
                                    .comNumIcon{
                                        font: 14px/24px "MicrosoftYaHei";
                                        white-space: nowrap;
                                    }
                                }
                            }
                        }
                        .xpkColor{
                            color: #FF6146 !important;
                        }
                        .sales{
                            font: 14px/18px "MicrosoftYaHei";
                            color: #8C8C8C;
                            margin-top: 8px;
                        }
                    }
                }
                .xpkGoodsBoxHover{
                    :hover{
                        .addBox{
                            display: block;
                        }
                    }
                }
                .zbjGoodsBox{
                    width: 558px;
                    height: 88px;
                    padding: 16px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #fff;
                    margin: 8px;
                    position: relative;
                    cursor: pointer;
                    &:hover{
                        border: 1px solid #FF6146;
                        .zbjBtn{
                            background: #FF6146 !important;
                            color: #fff !important;
                        }
                    }
                    .zbjActive{
                        width: 22px;
                        height: 22px;
                        position: absolute;
                        top: 16px;
                        right: 16px;
                    }
                    .zbjGoodsImg{
                        width: 88px;
                        height: 88px;
                        border-radius: 50%;
                    }
                    .zbjR{
                        width: 464px;
                        .zbjTitleBox{
                            width: 450px;
                            .zbjTitle{
                                max-width: 360px;
                                font: 16px/20px "MicrosoftYaHei";
                            }
                            .zbjType{
                                padding: 0 1px 0 4px;
                                height: 20px;
                                background: #FFF5F8;
                                border-radius: 4px;
                                margin-left: 4px;
                                .zbjTypeIcon{
                                    width: 16px;
                                    height: 16px;
                                }
                                .zbjTypeName{
                                    font: 12px/20px "MicrosoftYaHei";
                                    color: #9225FF;
                                }
                                .zbjTypeNameDa{
                                    color: #FF5A94 !important;
                                }
                            }
                        }
                        .zbjText{
                            font: 12px/16px "MicrosoftYaHei";
                            color: #8C8C8C;
                            margin-top: 6px;
                        }
                        .zbjComBox{
                            width: 464px;
                            height: 40px;
                            background: #FCF7F7;
                            border-radius: 14px;
                            margin-top: 6px;
                            .zbjCom{
                                font: 15px/40px "MicrosoftYaHei";
                                color: #FF6146;
                                padding: 0 16px;
                                .zbjComNum{
                                    font: 18px/40px "MicrosoftYaHei";
                                    padding-left: 4px;
                                }
                            }
                            .zbjBtn{
                                width: 106px;
                                height: 38px;
                                border: 1px solid #FF6146;
                                border-radius: 20px;
                                font: 15px/38px "MicrosoftYaHei";
                                color: #FF6146;
                                text-align: center;
                            }
                        }
                    }
                }
            }
       }
       .bindZbjBox{
            width: 690px;
            .bindTitle{
                font: 18px/24px "MicrosoftYaHei";
                color: #595959;
                padding-left: 8px;
                border-left: 3px solid #FF6146;
                margin-top: 16px;
            }
            .bindIpt{
                width: 658px;
                height: 44px;
                padding: 0 16px;
                background: #F6F6F6;
                border-radius: 8px;
                font: 14px/44px "MicrosoftYaHei";
                margin-top: 8px;
            }
            .bindArea{
                width: 658px;
                height: 98px;
                padding: 16px;
                background: #F6F6F6;
                border-radius: 8px;
                font: 14px/18px "MicrosoftYaHei";
                margin-top: 8px;
            }
            .bindImgBox{
                width: 164px;
                height: 164px;
                background: #F6F6F6;
                border-radius: 20px;
                margin-top: 8px;
                position: relative;
                .bindImgDel{
                    width: 44px;
                    height: 44px;
                    position: absolute;
                    right: -24px;
                    top: -24px;
                    cursor: pointer;
                }
                .bindImg{
                    width: 164px;
                    height: 164px;
                    border-radius: 20px;
                }
                .bindUpBox{
                    width: 164px;
                    height: 164px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .bindUpIcon{
                        width: 80px;
                        height: 80px;
                    }
                    .bindUpTips{
                        font: 14px/18px "MicrosoftYaHei";
                        color: #8C8C8C;
                    }
                }
            }
            .bindBtn{
                width: 160px;
                height: 44px;
                background: #FF6146;
                border-radius: 22px;
                font: 16px/44px "MicrosoftYaHei";
                color: #fff;
                text-align: center;
                margin: 16px auto 0 auto;
                cursor: pointer;
            }
       }
       .xpMask{
            width: 100vw;
            height: 100vh;
            background: rgba(0,0,0,0.5);
            position: fixed;
            left: 0;
            top: 0;
            z-index: 997;
            .xpPopup{
                width: 756px;
                height: 570px;
                background: #fff;
                border-radius: 8px;
                overflow: hidden;
                position: relative;
                z-index: 998;
                .xpClose{
                    width: 24px;
                    height: 24px;
                    position: absolute;
                    top: 28px;
                    right: 34px;
                    z-index: 999;
                    cursor: pointer;
                }
                .xpTop{
                    width: 756px;
                    height: 78px;
                    padding-bottom: 8px;
                    background: #FF6146;
                    .xpTopIcon{
                        width: 24px;
                        height: 24px;
                    }
                    .xpTopText{
                        font: 18px/24px "MicrosoftYaHei";
                        color: #fff;
                        margin-left: 4px;
                    }
                }
                .xpImg{
                    width: 756px;
                    height: 364px;
                    border-radius: 8px;
                    margin-top: -8px;
                }
                .xpTipsBox{
                    width: 756px;
                    margin-top: 12px;
                    .xpTipsText{
                        font: 18px/24px "MicrosoftYaHei";
                    }
                    .xpTipsNum{
                        font: 18px/24px "MicrosoftYaHei";
                        color: #8C8C8C;
                        padding-left: 12px;
                    }
                }
                .xpBtnBox{
                    width: 756px;
                    margin-top: 16px;
                    .xpBtnPrve{
                        width: 110px;
                        height: 42px;
                        border-radius: 22px;
                        border: 1px solid #FF6146;
                        font: 14px/42px "MicrosoftYaHei";
                        color: #FF6146;
                        text-align: center;
                        margin-right: 16px;
                        cursor: pointer;
                    }
                    .xpBtnNext{
                        width: 112px;
                        height: 44px;
                        border-radius: 22px;
                        background: #FF6146;
                        font: 14px/44px "MicrosoftYaHei";
                        color: #fff;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
       }
       .synBox{
            width: 458px;
            padding: 18px 0;
            .synTitle{
                font: bold 20px/24px "MicrosoftYaHei";
                margin-top: 8px;
                color: #000;
            }
            .synTips{
                font: 14px/18px "MicrosoftYaHei";
                margin-top: 8px;
                color: #000;
            }
            .synBtn{
                margin-top: 20px;
                .synRetry{
                    width: 80px;
                    height: 30px;
                    border-radius: 16px;
                    border: 1px solid #FF6146;
                    font: 14px/30px "MicrosoftYaHei";
                    color: #FF6146;
                    text-align: center;
                    cursor: pointer;
                }
                .synNext{
                    width: 100px;
                    height: 32px;
                    background: #FF6146;
                    border-radius: 16px;
                    font: 14px/30px "MicrosoftYaHei";
                    color: #fff;
                    text-align: center;
                    margin-left: 16px;
                    cursor: pointer;
                }
            }
       }
    }
</style>
<style>
    .el-progress-bar__inner{
		background: linear-gradient( to right, #FF8B78 0%, #FF5437 100%);
	}
</style>